import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/api";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Pricing } from "@/components/Pricing";
import { Work } from "@/components/Work";
import { Videos } from "@/components/Videos";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useLenis();
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main data-testid="landing-page" className="relative overflow-x-clip">
      <Header />
      <Hero />
      <Marquee />
      <Services />
      <Pricing />
      <Work />
      <Videos />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
